import { createSlice } from "@reduxjs/toolkit";
import { BonusTransactionsState } from "./types";
import { fetchBonusTransactions } from "./bonus-transactions-thunk";
import { ErrorType } from "@/shared/types";

const initialState: BonusTransactionsState = {
    transactions: [],
    stores: {},
    checks: {},
    isLoading: false,
    isFirstLoad: true,
    error: null,
    page: 1,
    limit: 50,
    totalPages: 0
}

const bonusTransactionsSlice = createSlice({
    name: 'bonusTransactions',
    initialState,
    reducers: {
        nextPage: (state) => {
            if (state.page < state.totalPages) {
                state.page += 1
            }
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchBonusTransactions.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchBonusTransactions.fulfilled, (state, action) => {
                state.isFirstLoad = false
                state.isLoading = false
                state.transactions = [...state.transactions, ...action.payload.transactions]
                state.stores = {...state.stores, ...action.payload.stores}
                state.checks = {...state.checks, ...action.payload.checks}
                state.error = null
                state.totalPages = Math.ceil(action.payload.total_count / state.limit)
            })
            .addCase(fetchBonusTransactions.rejected, (state, action) => {
                state.error = action.payload as ErrorType ?? null
                state.isLoading = false
            })
    },
})

export default bonusTransactionsSlice.reducer
export const { nextPage } = bonusTransactionsSlice.actions